module.exports = __webpack_public_path__ + "img/weyerhaeuser-logo.59428f49.jpg";